import { Utils } from 'cc-common';
import { Exclude, Type } from 'class-transformer';
import { UserPortfolioProfileResultDto } from '../user-portfolio-profile-result-dto';

export class UserCommunitiesResultDto {
    communityId: number;
    locationName: string;
    communityName: string;
    communityPhotoUrl: string;
    managementCompanyName: string;
    status: string;
    communityCode: string;
    city: string;
    county: string;
    description: string;
    fiscalYearEnd: string;
    legalName: string;
    master: string;
    office: string;
    communityServicesUrl: string;
    type: string;
    website: string;

    @Type(() => UserPortfolioProfileResultDto)
    manager: UserPortfolioProfileResultDto;

    @Type(() => UserPortfolioProfileResultDto)
    accountant: UserPortfolioProfileResultDto;

    @Type(() => Date)
    startDate: Date;

    @Type(() => Date)
    terminationDate: Date;

    @Type(() => Date)
    terminatingDate: Date;

    get userCommunityTerminatingDate(): Date {
        return this.terminatingDate;
    }

    @Exclude()
    isTerminating = Utils.notNullAndDefined(this.userCommunityTerminatingDate);

    // Transient
    showServices = false;
    communityServices: string;
    get websiteLink(): string {
        return !!this.website && this.website.startsWith('http') ? this.website : `http://${this.website}/`;
    }

    get managerUserDisplayText(): string {
        return Utils.notNullAndDefined(this.manager) ? this.manager.displayName : '';
    }

    get accountantUserDisplayText(): string {
        return Utils.notNullAndDefined(this.accountant) ? this.accountant.displayName : '';
    }
}
